<ng-template #modal let-selectModal>
  <div class="modal-header">
    <h2 id="select-wishlist-modal-title" class="modal-title">{{ headerTranslationKey | translate }}</h2>
    <button type="button" class="close" [title]="'dialog.close.text' | translate" (click)="hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  @if (showForm) {
  <form [formGroup]="formGroup" ishFormSubmit (ngSubmit)="submitForm()" novalidate>
    <div class="modal-body">
      <ish-select-wishlist-form [formGroup]="formGroup" [addMoveProduct]="addMoveProduct()" />
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-primary">
        {{ submitButtonTranslationKey | translate }}
      </button>
      <button type="button" class="btn btn-secondary" (click)="hide()">
        {{ 'account.wishlists.add_to_wishlist.cancel_button.text' | translate }}
      </button>
    </div>
  </form>
  } @else {
  <div class="modal-body" *ishProductContextAccess="let product = product">
    <span
      [ishServerHtml]="
        successTranslationKey
          | translate
            : {
                '0': product.name,
                '1': (selectedWishlistRoute$ | async),
                '2': (selectedWishlistTitle$ | async | ishHtmlEncode)
              }
      "
      [callbacks]="{ callbackHideDialogModal: callbackHideDialogModal }"
      data-testing-id="wishlist-success-link"
    ></span>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="hide()">
      {{ 'account.wishlists.add_to_wishlist.confirmation.ok_button.text' | translate }}
    </button>
  </div>
  }

  <ng-template #showSuccess>
    <div class="modal-body" *ishProductContextAccess="let product = product">
      <span
        [ishServerHtml]="
          successTranslationKey
            | translate
              : {
                  '0': product.name,
                  '1': (selectedWishlistRoute$ | async),
                  '2': (selectedWishlistTitle$ | async | ishHtmlEncode)
                }
        "
        [callbacks]="{ callbackHideDialogModal: callbackHideDialogModal }"
        data-testing-id="wishlist-success-link"
      ></span>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="hide()">
        {{ 'account.wishlists.add_to_wishlist.confirmation.ok_button.text' | translate }}
      </button>
    </div>
  </ng-template>
</ng-template>
